import { ComponentType } from "react"
import { IconProps } from "@chakra-ui/react"
import AlertIcon from "./AlertIcon"
import BoatIcon from "./BoatIcon"
import CarIcon from "./CarIcon"
import CorporateIcon from "./CorporateIcon"
import DollarIcon from "./DollarIcon"
import FoodPlateIcon from "./FoodPlateIcon"
import GiftIcon from "./GiftIcon"
import HeartIcon from "./HeartIcon"
import ManIcon from "./ManIcon"
import MicIcon from "./MicIcon"
import MusicIcon from "./MusicIcon"
import PhotoIcon from "./PhotoIcon"
import PlaneIcon from "./PlaneIcon"
import PresentationIcon from "./PresentationIcon"
import StarIcon from "./StarIcon"
import TagIcon from "./TagIcon"
import TaxiIcon from "./TaxiIcon"
import TicketIcon from "./TicketIcon"
import TrainIcon from "./TrainIcon"
import UserIcon from "./UserIcon"
import VideoIcon from "./VideoIcon"
import WineIcon from "./WineIcon"
import WomanIcon from "./WomanIcon"
import WristbandIcon from "./WristbandIcon"

export {
  AlertIcon, BoatIcon, CarIcon, CorporateIcon, DollarIcon, FoodPlateIcon,
  GiftIcon, HeartIcon, ManIcon, MicIcon, MusicIcon, PhotoIcon, PlaneIcon,
  PresentationIcon, StarIcon, TagIcon, TaxiIcon, TicketIcon, TrainIcon,
  UserIcon, VideoIcon, WineIcon, WomanIcon, WristbandIcon,
}

// Keyed by the kebab-case name stored in `event_groups.icon` on the API,
// which matches the source SVG filename. Insertion order here is the
// display order for the picker UI.
export const GUEST_LIST_ICONS: Record<string, ComponentType<IconProps>> = {
  tag: TagIcon,
  star: StarIcon,
  heart: HeartIcon,
  corporate: CorporateIcon,
  ticket: TicketIcon,
  wristband: WristbandIcon,
  alert: AlertIcon,
  dollar: DollarIcon,
  plane: PlaneIcon,
  train: TrainIcon,
  boat: BoatIcon,
  car: CarIcon,
  taxi: TaxiIcon,
  gift: GiftIcon,
  "food-plate": FoodPlateIcon,
  wine: WineIcon,
  user: UserIcon,
  man: ManIcon,
  woman: WomanIcon,
  presentation: PresentationIcon,
  video: VideoIcon,
  photo: PhotoIcon,
  mic: MicIcon,
  music: MusicIcon,
}

export const GUEST_LIST_ICON_NAMES = Object.keys(GUEST_LIST_ICONS)
